import { tkParse } from '@moke/vue-tk'
// import editState from './component/examine/editState.vue'
import verify from './component/examine/verify.vue'
export default {
  className: 'examine',
  fields: [
    {
      name: 'user',
      disabled: true,
      searchKey: ['phone', 'nickName'],
      render: (record) => {
        return (record.user && record.user.nickName) || '-'
      }
    }, {
      name: 'userIdentity',
      disabled: true
    },
    {
      name: 'house',
      disabled: true
    },
    {
      name: 'state',
      disabled: true
      // edit: {
      //   component: editState
      // }
    },
    {
      name: 'remarks',
      validators: [
        // (val) => val ? null : '房号不可为空'
      ]
    }
  ],
  search: [
    {
      name: 'user',
      disabled: false
    },
    'state'
  ],
  action: {
    // delete: false,
    create: false,
    verify: {
      type: 'row',
      text: '审核',
      component: verify,
      hidden: ({ record }) => {
        return record && record.state !== 'reviewed'
      }
    }
  },
  hooks: {
    async afterUpdate ({ data }) {
      console.log(data.user)
      if (data.state === 'pass') {
        await tkParse.put(`/classes/_User/${data.user}`, {
          isSelect: 'passed',
          useHourse: data.house
        })
      } else if (data.state === 'notPass') {
        await tkParse.put(`/classes/_User/${data.user}`, {
          isSelect: 'failure'
        })
      } else if (data.state === 'reviewed') {
        await tkParse.put(`/classes/_User/${data.user}`, {
          isSelect: 'notReviewed'
        })
      }
    }
  }
}
